import axios from "axios";

import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_IRPF_YEARS = `${API_URL}/irpf/intervalo`;
const GET_IRPF_JSON = `${API_URL}/irpf/certificado/`;
const GET_IRPF_PDF = `${API_URL}/irpf/certificadoPDF/`;
const GET_PDF_IRPF_JASPER = `${API_URL}/jasper/generarPDF_borradorIRPF`;
const GET_PDF_IRPF_HABILITADO = `${API_URL}/irpfhabilitado/verPdfIRPFhabilitado`;
const GET_IRPF_HABILITADO = `${API_URL}/irpfhabilitado/IRPFhabilitado`;
const GET_CUADRE_IRPF = `${API_URL}/irpf/cuadre/`;
const AUMENTAR_CUADRE_IRPF = `${API_URL}/irpf/cuadre/aumentar`;
const DISMINUIR_CUADRE_IRPF = `${API_URL}/irpf/cuadre/disminuir`;
/**
 * Obtiene los datos
 *
 * @param {String} token
 * @returns data
 */
export async function getYears() {
  return await axios({
    method: "GET",
    url: GET_IRPF_YEARS,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en recoger los años del IRPF")
    );
}
/**
 * Obtiene los datos del irpf en formato JSON
 *
 * @param {String} token
 * @returns data
 */
export async function getJSON(year) {
  return await axios({
    method: "GET",
    url: `${GET_IRPF_JSON}${year}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en recoger los datos del IRPF")
    );
}
/**
 * Obtiene el PDF del IRPF
 *
 * @param {String} token
 * @returns data
 */
export async function getPDFIRPF(year) {
  return await axios({
    method: "GET",
    url: `${GET_IRPF_PDF}${year}`,
    responseType: "blob",
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en recoger el PDF del IRPF")
    );
}
/**
 * Obtiene los datos
 *
 * @param {String} token
 * @returns data
 */
export async function getPDFJasper(anyo) {
  return await axios({
    method: "GET",
    url: `${GET_PDF_IRPF_JASPER}/${anyo}`,
    responseType: "blob",
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en generar el PDF del IRPF")
    );
}
/**
 * Obtiene un pdf
 *
 * @param {String} token
 * @returns data
 */
export async function verPdfIRPFhabilitado(anyo) {
  return await axios({
    method: "GET",
    url: `${GET_PDF_IRPF_HABILITADO}/${anyo}`,
    responseType: "blob",
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en generar el PDF del IRPF Habilitado")
    );
}
/**
 * Obtiene un boolean
 *
 * @param {String} token
 * @returns data
 */
export async function irpfHabilitado() {
  return await axios({
    method: "GET",
    url: `${GET_IRPF_HABILITADO}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en obtener el dato de IRPF Habilitado")
    );
}

export async function getCuadre() {
  return await axios({
    method: "GET",
    url: `${GET_CUADRE_IRPF}`,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger el Cuadre"));
}
export async function aumentarCuadre() {
  return await axios({
    method: "PUT",
    url: `${AUMENTAR_CUADRE_IRPF}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en aumentar el Cuadre")
    );
}
export async function disminuirCuadre() {
  return await axios({
    method: "PUT",
    url: `${DISMINUIR_CUADRE_IRPF}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en disminuir el Cuadre")
    );
}

